import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import PublicHome from '@/pages/PublicHome';
import AdminDashboard from '@/pages/AdminDashboard';

function ModeSwitcher() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.startsWith('/admin')) {
            document.body.setAttribute('data-mode', 'admin');
        } else {
            document.body.removeAttribute('data-mode');
        }
    }, [location.pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ModeSwitcher />
                <Routes>
                    <Route path="/" element={<PublicHome />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
                <Toaster richColors position="top-right" />
            </BrowserRouter>
        </div>
    );
}

export default App;
